"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isSameDateRange = exports.isSameDate = exports.isDateOverdue = exports.getYesterdayRange = exports.getTodayRange = exports.getStartOfToday = exports.getPastXDaysRange = exports.getOverdueRange = exports.getNextXDaysRange = exports.getDisplayDate = exports.getDateStringFromDateTimeString = exports.getDateStringAsDisplayText = exports.getDateStringAsDate = exports.getDateFormatToDays = void 0;
var _alloyReactDatetime = require("@adsk/alloy-react-datetime");
/**
 *
 * @param dateString - a string of the format "YYYY-MM-DD"
 *
 * @returns the date (with the current locale) created from the string
 */
const getDateStringAsDate = dateString => {
  // if there's already timezone info included, we can use the built-in date parser
  // without any trouble
  if (dateString.length > 10 && dateString.includes("Z")) {
    return new Date(dateString);
  }
  const [yearString, monthString, dayString] = dateString.split("-");
  const newDate = new Date(Date.UTC(parseInt(yearString, 10), parseInt(monthString, 10) - 1,
  // monthIndex is an index, unlike day and year
  parseInt(dayString, 10),
  // setting the target time in the date to be an hour past midday avoids all
  // daylight savings parse issues.
  13));
  // This adjusts the date to handle the timezone.
  newDate.setTime(newDate.getTime() + newDate.getTimezoneOffset() * 60 * 1000);
  // at this point, the date should be correct for the local tz,
  // and the time on it will be within an hour of 13:00.
  return newDate;
};
exports.getDateStringAsDate = getDateStringAsDate;
const getDateStringFromDateTimeString = dateTimeString => {
  const date = new Date(dateTimeString);
  if (isNaN(date.getTime())) {
    return ""; // will raise an error by schema validation
  }
  const [dateString] = new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString().split("T");
  return dateString;
};
exports.getDateStringFromDateTimeString = getDateStringFromDateTimeString;
const getDateStringAsDisplayText = (dateString, format) => {
  const date = getDateStringAsDate(dateString);
  return (0, _alloyReactDatetime.displayDate)(date, {
    format
  });
};
exports.getDateStringAsDisplayText = getDateStringAsDisplayText;
const padZeroes = (t, maxLength) => t.toString().padStart(maxLength, "0");

// This doesn't use ISO because we want to use the local date, not the UTC date.
// In locales with a positive UTC offset, midnight falls on the day before.
const getDateFormatToDays = newDate => [padZeroes(newDate.getFullYear(), 4), padZeroes(newDate.getMonth() + 1, 2), padZeroes(newDate.getDate(), 2)].join("-");
exports.getDateFormatToDays = getDateFormatToDays;
const isSameDate = (x, y) => {
  if (x === null && y === null) {
    return true;
  }
  if (x === null || y === null) {
    return false;
  }
  return +new Date(x) - +new Date(y) === 0;
};
exports.isSameDate = isSameDate;
const getStartOfToday = () => {
  const startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  return startOfToday;
};
exports.getStartOfToday = getStartOfToday;
const isSameDateRange = (a, b) => {
  if (!a && !b) {
    return true;
  }
  if (!a) {
    a = {
      startDate: null,
      endDate: null
    };
  }
  if (!b) {
    b = {
      startDate: null,
      endDate: null
    };
  }
  return isSameDate(a.startDate, b.startDate) && isSameDate(a.endDate, b.endDate);
};
exports.isSameDateRange = isSameDateRange;
const getOverdueRange = () => {
  const millisecondsUntilEndOfYesterday = new Date().setHours(0, 0, 0, 0) - 1;
  return {
    startDate: null,
    endDate: new Date(millisecondsUntilEndOfYesterday)
  };
};
exports.getOverdueRange = getOverdueRange;
const getTodayRange = () => {
  const startOfToday = getStartOfToday();
  const millisecondsUntilEndOfToday = new Date(startOfToday).setDate(startOfToday.getDate() + 1) - 1;
  return {
    startDate: startOfToday,
    endDate: new Date(millisecondsUntilEndOfToday)
  };
};
exports.getTodayRange = getTodayRange;
const getYesterdayRange = () => {
  const startOfYesterday = new Date();
  startOfYesterday.setDate(startOfYesterday.getDate() - 1);
  startOfYesterday.setHours(0, 0, 0, 0);
  const millisecondsUntilEndOfYesterday = new Date().setHours(0, 0, 0, 0) - 1;
  return {
    startDate: startOfYesterday,
    endDate: new Date(millisecondsUntilEndOfYesterday)
  };
};
exports.getYesterdayRange = getYesterdayRange;
const getNextXDaysRange = days => {
  const startOfToday = getStartOfToday();
  const millisecondsFromNowInXPlusOneDays = new Date(startOfToday).setDate(startOfToday.getDate() + days);
  const endOfRange = new Date(millisecondsFromNowInXPlusOneDays - 1);
  return {
    startDate: startOfToday,
    endDate: endOfRange
  };
};
exports.getNextXDaysRange = getNextXDaysRange;
const getPastXDaysRange = days => {
  const startOfToday = getStartOfToday();
  const millisecondsUntilEndOfToday = new Date(startOfToday).setDate(startOfToday.getDate() + 1) - 1;
  return {
    startDate: new Date(startOfToday.setDate(startOfToday.getDate() - days)),
    endDate: new Date(millisecondsUntilEndOfToday)
  };
};
exports.getPastXDaysRange = getPastXDaysRange;
const isDateOverdue = date => {
  const startOfTomorrow = getStartOfToday();
  startOfTomorrow.setDate(startOfTomorrow.getDate() + 1);
  const startOfDate = new Date(date);
  startOfDate.setHours(0, 0, 0, 0);
  return startOfTomorrow > startOfDate;
};
exports.isDateOverdue = isDateOverdue;
const getDisplayDate = date => (0, _alloyReactDatetime.displayDate)(new Date(date), {
  timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
});
exports.getDisplayDate = getDisplayDate;
//# sourceMappingURL=dateUtils.js.map